import { NoteSliceState } from '@/domains/notes/store/types/noteTypes';

const paginationInitialState = {
  numberOfItems: 0,
  first: '1',
  last: undefined,
  previous: '0',
  next: '0',
  page: 1,
  perPage: 20,
};

export const noteInitialState: NoteSliceState = {
  data: {
    listings: [],
    pagination: paginationInitialState,
  },
  statuses: {
    isLoading: false,
    noteUpdateInProgress: {},
  },
  noteEntities: [],
  reminders: {
    listings: [],
    pagination: paginationInitialState,
  },
};
